import { render } from "./BaseAvatar.vue?vue&type=template&id=0fab7ea0&scoped=true"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"

import "./BaseAvatar.vue?vue&type=style&index=0&id=0fab7ea0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fab7ea0"

export default script